const METERS_PER_MILE = 1609.344;
const KM_PER_MILE = 1.609_34;
const MILES_PER_KM = 0.621_371;
const MILES_PER_INCH = 0.000_015_782_828_3;

export function metersToMiles(meters: number): number {
  return meters / METERS_PER_MILE;
}

export function kmToMiles(km: number): number {
  return km * MILES_PER_KM;
}

export function milesToKm(miles: number): number {
  return miles * KM_PER_MILE;
}

export function inchToMiles(inch: number): number {
  return inch * MILES_PER_INCH;
}

export function getDistanceFromLatLonInKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number {
  const R = 6371; // Radius of the earth in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/** Countries that use miles instead of kilometers for distance display. */
export const IMPERIAL_DISTANCE_COUNTRIES = new Set(["US", "LR", "MM"]);
